import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { auth, firestore } from "../firebaseConfig";

const RECORD_AUDIT_COLLECTION = "recordChangeLogs";

const sanitizeForFirestore = (value) => {
  if (value === undefined || typeof value === "function") return null;
  if (value === null) return null;
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeForFirestore(item));
  }
  if (typeof value === "object") {
    return Object.entries(value).reduce((acc, [key, currentValue]) => {
      acc[key] = sanitizeForFirestore(currentValue);
      return acc;
    }, {});
  }
  return value;
};

export const buildRecordAuditPayload = ({
  action,
  entityType,
  companyName,
  recordId,
  sourceComponent,
  oldData,
  newData,
}) => {
  const currentUser = auth?.currentUser || null;
  const payload = {
    action,
    entityType,
    companyName: companyName || null,
    recordId: recordId || null,
    sourceComponent: sourceComponent || null,
    actorUid: currentUser?.uid || null,
    actorEmail: currentUser?.email || null,
    changedAt: typeof serverTimestamp === "function" ? serverTimestamp() : null,
    oldData: sanitizeForFirestore(oldData),
  };

  if (action === "edit") {
    payload.newData = sanitizeForFirestore(newData);
  }

  return payload;
};

export const logRecordAuditEvent = async (params) => {
  if (!firestore) return false;
  try {
    await addDoc(
      collection(firestore, RECORD_AUDIT_COLLECTION),
      buildRecordAuditPayload(params)
    );
    return true;
  } catch (error) {
    console.error("Failed to write record audit log", error);
    return false;
  }
};

export const __recordAuditCollection = RECORD_AUDIT_COLLECTION;
